"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pic = _interopRequireDefault(require("./components/pic"));
var _text = _interopRequireDefault(require("./components/text"));
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PicBase',
  components: {
    PicImgBase: _pic.default,
    InnerText: _text.default
  },
  props: ['children']
};